// sagas/fiuSaga.ts
import { takeLatest, call, put, all } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { PayloadAction } from '@reduxjs/toolkit';
import { goalActions as actions } from '.';
import { authenticatedGet } from 'remote/api';

function* getNetworthSaga(action: PayloadAction<any>) {
  try {
    const { isGroup } = action.payload;
    const response: AxiosResponse<any> = yield call(
      authenticatedGet,
      `${process.env.REACT_APP_API_URL}/networth?group=${isGroup}`,
    );

    yield put(actions.getNetworthSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getNetworthFailure(error.message));
  }
}
function* networthGrowthSaga(action: PayloadAction<any>) {
  try {
    const response: AxiosResponse<any> = yield call(
      authenticatedGet,
      `${process.env.REACT_APP_API_URL}/networth?filter=${action.payload}`,
    );

    yield put(actions.networthGrowthSuccess(response.data));
  } catch (error: any) {
    yield put(actions.networthGrowthFailure(error.message));
  }
}

export function* getNetworthsaga() {
  yield all([
    takeLatest(actions.getNetworth.type, getNetworthSaga),
    takeLatest(actions.networthGrowth.type, networthGrowthSaga),
  ]);
}
